"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const ContactNameTooltip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'If you prefer to use a pseudonym or keep your name fully anonymous in the Public Work Search, you may do so by ' +
        "entering either your pseudonym or 'Anonymous' in the First Name field.", place: 'right' }));
exports.default = ContactNameTooltip;
